var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0773C0 22.1355 0.857875 22.9934 1.91612 22.9934H33.0839C34.1421 22.9934 35 22.1355 35 21.0773C35 20.019 34.1421 19.1612 33.0839 19.1612H1.91612C0.857877 19.1612 0 20.019 0 21.0773ZM6.5 11.4967C6.5 12.5549 7.35788 13.4128 8.41612 13.4128H27.5839C28.6421 13.4128 29.5 12.5549 29.5 11.4967C29.5 10.4385 28.6421 9.58059 27.5839 9.58059H8.41612C7.35788 9.58059 6.5 10.4385 6.5 11.4967ZM1.91612 0C0.857877 0 0 0.857875 0 1.91612C0 2.97436 0.857875 3.83223 1.91612 3.83223H33.0839C34.1421 3.83223 35 2.97436 35 1.91612C35 0.857875 34.1421 0 33.0839 0H1.91612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b619c2fe13522d571cbe6759533b3a11.svg";
export { ForwardRef as ReactComponent };